// frontend/src/components/calendar/newCalendar.js
//
// What a calendar created for a location starts as: named after the location
// in the merchant's language, Monday–Friday working, deliveries due on a closed
// day moved to the next working day. The merchant edits it in the calendar
// modal afterwards.

import { charLength } from '../../constants/orgFieldLimits';

/** api.serializers.CalendarSerializer calendar_name max_length. */
export const CALENDAR_NAME_MAX = 80;

const ELLIPSIS = '…';

/**
 * The name a new calendar gets for `locationName`. A location name may be up to
 * 255 characters, so a long one is shortened with an ellipsis until the whole
 * name fits CALENDAR_NAME_MAX — the merchant sees the "…" and can rename it.
 */
function calendarNameFor(locationName, t) {
  const location = locationName.trim();
  if (!location) return t('locationSetup.calendar.createNew');
  const full = t('locationSetup.calendar.defaultName', { location });
  const overflow = charLength(full) - CALENDAR_NAME_MAX;
  if (overflow <= 0) return full;
  const chars = [...location];
  const shortened = chars.slice(0, chars.length - overflow - ELLIPSIS.length).join('') + ELLIPSIS;
  return t('locationSetup.calendar.defaultName', { location: shortened });
}

/**
 * The create payload for a location's new calendar.
 *
 * @param {string} locationName
 * @param {(key: string, opts?: object) => string} t
 */
export function newCalendarPayload(locationName, t) {
  return {
    calendar_name: calendarNameFor(locationName, t),
    description: '',
    working_days_pattern: {
      monday: true, tuesday: true, wednesday: true, thursday: true, friday: true,
      saturday: false, sunday: false,
    },
    closed_day_delivery_rule: 'NEXT',
    is_active: true,
  };
}
